document.addEventListener('alpine:init', () => {
    const DATA_POINTS = document.getElementById('ql-data-points')

    Alpine.data('admin_shows_x_data', () => ({
        open_status: false,
        open_platform: false,
        open_creation: false,
        open_plan: false,
        open_itunes: false,
        open_feature: false,
        status_options: [],
        platform_options: [],
        creation_options: [],
        plan_options: [],
        itunes_options: [],
        feature_options: [],
        selected_status: [],
        selected_platform: null,
        selected_creation: null,
        selected_plan: [],
        selected_itunes: null,
        selected_feature: [],
        search_query: null,
        submit_path: DATA_POINTS.dataset.submitPath,
        init() {
            this.setup_selected()
            this.setup_options()
        },
        setup_selected() {
            // set the selected filters when page loads
            this.search_query = DATA_POINTS.dataset.searchQuery
            this.selected_status = DATA_POINTS.dataset.selectedStatus ? DATA_POINTS.dataset.selectedStatus.split(',') : []
            this.selected_platform = DATA_POINTS.dataset.selectedPlatform
            this.selected_creation = DATA_POINTS.dataset.selectedCreation
            this.selected_plan = DATA_POINTS.dataset.selectedPlan ? DATA_POINTS.dataset.selectedPlan.split(',') : []
            this.selected_itunes = DATA_POINTS.dataset.selectedItunes
            this.selected_feature = DATA_POINTS.dataset.selectedFeature ? DATA_POINTS.dataset.selectedFeature.split(',') : []
        },
        setup_options() {
            const rawStatusOptions = JSON.parse(DATA_POINTS.dataset.rawStatusOptions)
            const rawPlatformOptions = ['Hosting', 'Prefix']
            const rawPlanOptions = JSON.parse(DATA_POINTS.dataset.rawPlanOptions)
            const rawFeatureOptions = JSON.parse(DATA_POINTS.dataset.rawFeatureOptions)

            // create an array of readable labels and values for the show status options
            this.status_options = Object.entries(rawStatusOptions).map(([key, value]) => {
                return {
                    label: this.make_readable(key),
                    value: value
                };
            });

            this.platform_options = rawPlatformOptions.map(option => {
                return {
                    label: option,
                    value: option.toLowerCase()
                }
            })

            this.creation_options = [
                {label: 'Ascending', value: 'asc'},
                {label: 'Descending', value: 'desc'}
            ]

            // create an array of readable labels and values for the show plan options
            this.plan_options = Object.entries(rawPlanOptions).map(([key, value]) => {
                return {
                    label: this.make_readable(key),
                    value: value
                };
            });

            this.itunes_options = [
                {label: 'Blocked', value: 'blocked'},
                {label: 'Not Blocked', value: 'not_blocked'}
            ]

            // create an array of readable labels and values for the show feature options
            this.feature_options = Object.entries(rawFeatureOptions).map(([key, value]) => {
                return {
                    label: this.make_readable(key),
                    value: value
                };
            });
        },
        make_readable(key) {
            // this function converts snake_case keys to readable labels
            return key
                .replace(/_/g, ' ')
                .replace(/\b\w/g, char => char.toUpperCase());
        },
        deselect_filter(type, value) {
            switch (type) {
                case 'status':
                    this.selected_status = this.selected_status.filter(status => status !== value);
                    document.querySelectorAll('input[name="show-status"]').forEach((input) => {
                        if (input.value === value) {
                            input.checked = false;
                        }
                    });
                    break
                case 'platform':
                    this.selected_platform = null;
                    document.querySelectorAll('input[name="platform"]').forEach((input) => {
                        input.checked = false;
                    });
                    break
                case 'creation':
                    this.selected_creation = null;
                    document.querySelectorAll('input[name="show-creation"]').forEach((input) => {
                        input.checked = false;
                    });
                    break
                case 'plan':
                    this.selected_plan = this.selected_plan.filter(plan => plan !== value);
                    document.querySelectorAll('input[name="show-plan"]').forEach((input) => {
                        if (input.value === value) {
                            input.checked = false;
                        }
                    });
                    break
                case 'itunes':
                    this.selected_itunes = null;
                    document.querySelectorAll('input[name="itunes-block"]').forEach((input) => {
                        input.checked = false;
                    });
                    break
                case 'features':
                    this.selected_feature = this.selected_feature.filter(feature => feature !== value);
                    document.querySelectorAll('input[name="features"]').forEach((input) => {
                        if (input.value === value) {
                            input.checked = false;
                        }
                    });
                    break
                default:
                    throw new Error('Unknown filter type')
            }

            this.handle_filter()
        },
        handle_select_submit(type, value, $event) {
            // we ensure we remove other checked values before submitting to prevent
            // duplicate filter params

            switch (type) {
                case 'status':
                    if (this.selected_status.includes(value)) {
                        this.selected_status = this.selected_status.filter(status => status !== value);
                    } else {
                        this.selected_status.push(value);
                    }
                    this.open_status = false;
                    break
                case 'platform':
                    if (this.selected_platform === value) {
                        this.selected_platform = null;
                        document.querySelectorAll('input[name="platform"]').forEach((input) => {
                            input.checked = false;
                        });
                    } else {
                        this.selected_platform = value;
                        document.querySelectorAll('input[name="platform"]').forEach((input) => {
                            if (input.value !== value) {
                                input.checked = false;
                            }
                        });
                    }
                    this.open_platform = false;
                    break
                case 'creation':
                    if (this.selected_creation === value) {
                        this.selected_creation = null;
                        document.querySelectorAll('input[name="show-creation"]').forEach((input) => {
                            input.checked = false;
                        });
                    } else {
                        this.selected_creation = value;
                        document.querySelectorAll('input[name="show-creation"]').forEach((input) => {
                            if (input.value !== value) {
                                input.checked = false;
                            }
                        });
                    }
                    this.open_creation = false
                    break
                case 'plan':
                    if (this.selected_plan.includes(value)) {
                        this.selected_plan = this.selected_plan.filter(plan => plan !== value);
                    } else {
                        this.selected_plan.push(value);
                    }
                    this.open_plan = false;
                    break
                case 'itunes':
                    if (this.selected_itunes === value) {
                        this.selected_itunes = null;
                        document.querySelectorAll('input[name="itunes-block"]').forEach((input) => {
                            input.checked = false;
                        });
                    } else {
                        this.selected_itunes = value;
                        document.querySelectorAll('input[name="itunes-block"]').forEach((input) => {
                            if (input.value !== value) {
                                input.checked = false;
                            }
                        });
                    }
                    this.open_itunes = false
                    break
                case 'features':
                    if (this.selected_feature.includes(value)) {
                        this.selected_feature = this.selected_feature.filter(feature => feature !== value);
                    } else {
                        this.selected_feature.push(value);
                    }
                    this.open_feature = false;
                    break
                default:
                    throw 'unrecognized filter type'
            }

            this.handle_filter()
        },
        handle_filter() {
            let params = new URLSearchParams()
            if (this.search_query) {
                params.append('search', this.search_query);
            }

            if (this.selected_status && this.selected_status.length > 0) {
                this.selected_status.forEach(status => {
                    params.append('show-status[]', status);
                });
            }

            if (this.selected_platform) {
                params.append('platform', this.selected_platform);
            }

            if (this.selected_creation) {
                params.append('show-creation', this.selected_creation);  // only one value (asc/desc)
            }

            if (this.selected_plan && this.selected_plan.length > 0) {
                this.selected_plan.forEach(plan => {
                    params.append('show-plan[]', plan);
                });
            }

            if (this.selected_itunes) {
                params.append('itunes-block', this.selected_itunes)
            }

            if (this.selected_feature && this.selected_feature.length > 0) {
                this.selected_feature.forEach(feature => {
                    params.append('features[]', feature);
                });
            }
            const queryParamString = params.toString()

            console.log(`${this.submit_path}${queryParamString ? '?' : ''}${queryParamString}`)
            window.location.href = `${this.submit_path}${queryParamString ? '?' : ''}${queryParamString}`
        },
        reset_filter() {
            window.location.href = `${this.submit_path}`
        }
    }))
})